import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BpgChapterHomePageService {
  private readonly bpgChapterDetailsSource = new BehaviorSubject('default message');
  bpgChapterData = this.bpgChapterDetailsSource.asObservable();

  constructor() { }
  bpgChapterDetails(message:any){
    this.bpgChapterDetailsSource.next(message);

  }
  

}
